import axios from 'axios';

import { api } from './axios';

const AwsService = {

  getSignedUrl: async (params) => {
    const response = await api.get(`/aws/get-signed-url?filename=${params.filename}&contentType=${params.contentType}&partnerId=${params.partnerId}`);
    return response.data;
  },

   uploadFile: async (params) => {
    try {
       await axios.put(params.url, params.file, {
        headers: {
          'Content-Type': params.contentType,
        },
      });
      return { imageUrl: params.url.split('?')[0], success: true };
    } catch (error) {
      console.error('Error uploading file:', error);
      throw error;
    }
  }

};

export default AwsService;
